/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import React, { FunctionComponent } from "react";
import { theme } from "../../../themes/global";
import { HTMLCustomProps } from "../../../types/css";
import styled from "@emotion/styled";

export const Einput = styled("input")`
  appearance: none;
  background-color: ${theme.color.white};
  border-radius: 4px;
  color: ${theme.color.black};
  font-size: 16px;
  font-height: ${theme.font.buttonLineHight};
  box-shadow: 0px 1px 4px rgba(51, 51, 51, 0.25);
  border: none;
  margin: 0;
  outline: none;
  padding: 16px 12px;
`;

interface Props {
  type?: string;
  name?: string;
  value?: string | number;
}

const Input: FunctionComponent<HTMLCustomProps<HTMLInputElement> & Props> = ({
  children,
  ...rest
}) => {
  return <Einput {...rest}></Einput>;
};

export default Input;
